import MainComponent from "components/Main";
import PropTypes from 'prop-types';

export default class SelectAbstract extends MainComponent {
    static propTypes = {
        labelKey: PropTypes.string,
        translate: PropTypes.bool,
        items: PropTypes.array,
        placeHolder: PropTypes.string,
        fixedHolder: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        editable: PropTypes.bool,
    };
    static defaultProps = {
        labelKey: "name",
        translate: false,
        items: [],
        placeHolder: "",
        fixedHolder: "",
        onChange: null,
        value: "",
        editable: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            opened: false,
            index: -1,
        };
    }

    get currentText() {
        return this.selectorLabel?.innerHTML || "";
    }

    getMainStyle() {
        return "";
    }

    getPopupStyle() {
        return "text p1";
    }

    componentWillUnmount() {
        this.clearCnt();
    }

    validate() {
        if (this.state.index !== -1)
            return this._helper.dom.removeClass(this.selectWrap, "unvalid");

        return this._helper.dom.addClass(this.selectWrap, "unvalid");
    }

    selectItem(index, it, e) {
        this.state.index = index;
        this.setOpenedState(false);
        this.onItemSelect(it, e);
        this.validate();
    }

    onItemSelect({ id }) {
        if (this.props.onChange)
            this.props.onChange(id);
    }

    toggleOpenedState() {
        this.setOpenedState(!this.state.opened);
    }

    setOpenedState(opened) {

        if (!this.props.editable)
            return;

        if (!opened && this.popup)
            this.domNode.appendChild(this.popup);

        this.setState({ opened }, () => {
            if (opened)
                this.onPopupOpen();
        });

        this.clearCnt();

        if (opened)
            this.openCnt = this._helper.on(window, "mouseup", this.checkHide.bind(this));
    }

    getPopupCoords() {
        return this._helper.dom.coords(this.popup);
    }

    onPopupOpen() {
        document.getElementById("layout").appendChild(this.popup);

        const selectorC = this._helper.dom.coords(this.selector);
        const bodyC = this._helper.dom.coords(document.body);

        this._helper.dom.styleProp(this.popup, {
            selectorW: selectorC.w + "px",
            selectorH: selectorC.h + "px",
        });

        let popCoords = this.getPopupCoords();
        const isMoreTop = (selectorC.y + selectorC.h + popCoords.h > bodyC.h - 50) && (selectorC.y > (bodyC.h / 2));
        const isMoreRight = (selectorC.x + popCoords.w > bodyC.w - 25) && (selectorC.x > (bodyC.w / 2));

        this._helper.dom.addRemoveClass(this.popup, "top", isMoreTop);
        this._helper.dom.addRemoveClass(this.popup, "right", isMoreRight);

        this._helper.dom.styleProp(this.popup, {
            left: selectorC.x + "px",
            top: selectorC.y + "px",
        });

        popCoords = this.getPopupCoords();

        const overflowed = this.popup.firstChild.scrollWidth > popCoords.w;
        this._helper.dom.addRemoveClass(this.popup, "overflowed", overflowed);
    }

    checkHide({ target }) {
        const isSelector = this._helper.dom.isChildOf(target, this.selector);
        const isPopup = this._helper.dom.isChildOf(target, this.popup);

        if (isSelector || isPopup)
            return;

        this.setOpenedState(false);
    }

    clearCnt() {
        this._helper.disconnect(this.openCnt);
    }

    getPopupItemStyle() {
        return "";
    }

    getPopupItemLabel(info) {
        const label = info[this.props.labelKey];
        return this.props.translate ? this.tr(label) : label;
    }

    getLeftIcon() {
        return "";
    }

    getRightIcon() {
        return "";
    }

    checkSelectedValue({ index }, { value, items }) {
        if (index < 0 && value !== "") {
            for (let i in items) {
                const item = items[i];
                if (item.id === value) {
                    index = parseInt(i);
                    this.state.index = index;
                    break;
                }
            }
        }

        return index;
    }

    getItems() {
        return this.items || this.props.items;
    }

    renderSelector(items, opened, index) {
        const { placeHolder, fixedHolder } = this.props;
        const text = fixedHolder ? this.tr(fixedHolder) : (this.state.index < 0 ? (placeHolder ? this.tr(placeHolder) : "") : (items[index] ? this.getPopupItemLabel(items[index]) : ""));

        const leftIcon = this.getLeftIcon(opened);
        const rightIcon = this.getRightIcon(opened);

        return (
            <div ref={el => this.selector = el} className="selector flex centerV hand" onClick={this.toggleOpenedState.bind(this)}>
                {!!leftIcon && leftIcon}
                <div
                    ref={el => this.selectorLabel = el}
                    className={`selectLabel flex1 text button2 firstUpper ${(index < 0 && !fixedHolder) ? "placeholder" : ""}`}>
                    {text}
                </div>
                {!!rightIcon && rightIcon}
            </div>
        );
    }

    insertPopupItem(it, i) {
        return (
            <div
                key={i}
                className={"popupItem hand flex centerV between" + this.getPopupItemStyle(it, i)}
                onClick={this.selectItem.bind(this, i, it)}
            >
                {this.getPopupItemLabel(it, i)}
                {!!it.rightIcon && <div style={{ marginLeft: "8px" }}>{it.rightIcon}</div>}
            </div>
        );
    }

    insertLine(i) {
        return <div key={i} className="popupLine"></div>;
    }

    renderPopup(items) {
        return (
            <div
                ref={el => this.popup = el}
                className={`selectPopup flex pos abs ${this.getMainStyle()} ${this.getPopupStyle()}`}
                style={{ "--left": "-100vw" }}
            >
                <div className="flex1 scrolling">
                    {items.map((it, i) => {
                        return (it.line === true) ? this.insertLine(i) : this.insertPopupItem(it, i);
                    })}
                </div>
            </div>
        );
    }

    render() {
        const { opened } = this.state;
        const items = this.getItems();
        const openedCl = opened ? " opened" : "";

        const index = this.checkSelectedValue(this.state, this.props);

        return (
            <div
                ref={el => this.domNode = el}
                className={`selectBox${openedCl} ` + this.getMainStyle()}
            >
                {this.renderSelector(items, opened, index)}
                {opened && this.renderPopup(items)}
            </div>
        );
    }
}
